import { AxiosResponse } from 'axios'
import axiosInstance from '../../config/axios'
import { serverPath } from '../../constants/api-endpoints'
import { AppDispatch, RootState } from '../index'
import { setCabinetsInfoSlice, setCabinetsPagination, setDefaultCabinetList } from './reduser'
import { ICabinetsInfoResponseDto } from '../../dto/cabinets/cabinetsInfo/cabinetsInfo.response.dto'
import { useMessage } from '../../hooks/useMessage'
import { setLoading } from '../auth/reducer'
import { CreateCabinetRequestDto } from '../../dto/cabinets/createCabinet/createCabinet.request.dto'
import { errorMapper } from '../../utils/errorMapper'
import { ErrorMessages } from '../../constants/errors'

export const createCabinet = (data: CreateCabinetRequestDto) => async (dispatch: AppDispatch) => {
  const { success, error } = useMessage()
  try {
    dispatch(setLoading(true))

    const res = await axiosInstance.post<AxiosResponse<CreateCabinetRequestDto>>(serverPath.CREATE_CABINET, {
      ...data
    })

    success("Кабинет успешно создан!")

    return res;
  } catch (e: any) {
    const message = e.response?.data?.message || e.message || 'Не удалось создать кабинет.'

    error(message)

    throw new Error(message);
  } finally {
    dispatch(setLoading(false))
  }
}

export const loadCabinetList = () => async (dispatch: AppDispatch, getState: () => RootState) => {
  const { error } = useMessage()
  const { cabinetList } = getState();

  try {
    const res: AxiosResponse<ICabinetsInfoResponseDto> = await axiosInstance.get(serverPath.CABINETS_INFO, {
      params: {
        page: cabinetList.pagination.current,
        limit: cabinetList.pagination.pageSize
      },
    })

    dispatch(setCabinetsInfoSlice(res.data))
  } catch (e: any) {
    error(errorMapper(ErrorMessages.REMOVE_DATA, e), 'Ошибка загрузки кабинетов')

    dispatch(setDefaultCabinetList())
  }
}

export const setCabinetPagination = (pagination: { current: number, pageSize: number }) => async (dispatch: AppDispatch) => {
  dispatch(setCabinetsPagination(pagination))
  dispatch(loadCabinetList())
}
